import { apiListTypes } from './actionTypes';

//REVISAR SI ESTA ACCION RECIBE ALGUN PARAMETRO

//GET API LIST
export const getApiList = (data: any) => {
  return {
    type: apiListTypes.GET_API_LIST,
    data,
  };
};

export const getApiListSuccess = (payload: any) => ({
  type: apiListTypes.GET_API_LIST_SUCCESS,
  payload,
});

export const getApiListFail = (error: any) => ({
  type: apiListTypes.GET_API_LIST_FAIL,
  payload: error,
});

//ADD API LIST
export const addApiList = (apiAdd: any) => {
  return {
    type: apiListTypes.ADD_API_LIST,
    payload: { apiAdd },
  };
};

export const addApiListSuccessful = (apiAdd: any) => {
  return {
    type: apiListTypes.ADD_API_LIST_SUCCESS,
    payload: apiAdd,
  };
};

export const addApiListFailed = (error: any) => {
  return {
    type: apiListTypes.ADD_API_LIST_FAIL,
    payload: error,
  };
};

//ADD SUB API

export const addSubApi = (apiAdd: any) => {
  return {
    type: apiListTypes.ADD_SUB_API,
    payload: { apiAdd },
  };
};

export const addSubApiSuccessful = (apiAdd: any) => {
  return {
    type: apiListTypes.ADD_SUB_API_SUCCESS,
    payload: apiAdd,
  };
};

export const addSubApiFailed = (error: any) => {
  return {
    type: apiListTypes.ADD_SUB_API_FAIL,
    payload: error,
  };
};

//UPDATE SUB API

export const updateSubApi = (apiUpdate: any) => {
  return {
    type: apiListTypes.UPDATE_SUB_API,
    payload: { apiUpdate },
  };
};

export const updateSubApiSuccessful = (apiUpdate: any) => {
  return {
    type: apiListTypes.UPDATE_SUB_API_SUCCESS,
    payload: apiUpdate,
  };
};

export const updateSubApiFailed = (error: any) => {
  return {
    type: apiListTypes.UPDATE_SUB_API_FAIL,
    payload: error,
  };
};

//DELETE SUB API
export const deleteSubApi = (payload: any) => {
  return {
    type: apiListTypes.DELETE_SUB_API,
    payload,
  };
};

export const deleteSubApiSuccess = (payload: any) => {
  return {
    type: apiListTypes.DELETE_SUB_API_SUCCESS,
    payload,
  };
};

export const deleteSubApiFail = (error: any) => {
  return {
    type: apiListTypes.DELETE_SUB_API_FAIL,
    payload: error,
  };
};

//DELETE API LIST
export const deleteApiList = (id: any) => {
  return {
    type: apiListTypes.DELETE_API_LIST,
    payload: id,
  };
};

export const deleteApiListSuccess = (payload: any) => {
  return {
    type: apiListTypes.DELETE_API_LIST_SUCCESS,
    payload,
  };
};

export const deleteApiListFail = (error: any) => {
  return {
    type: apiListTypes.DELETE_API_LIST_FAIL,
    payload: error,
  };
};

//UPDATE API LIST
export const updateApiList = (api: any) => {
  return {
    type: apiListTypes.UPDATE_API_LIST,
    payload: { api },
  };
};

export const updateApiListSuccess = (api: any) => {
  return {
    type: apiListTypes.UPDATE_API_LIST_SUCCESS,
    payload: api,
  };
};

export const updateApiListFail = (error: any) => {
  return {
    type: apiListTypes.UPDATE_API_LIST_FAIL,
    payload: error,
  };
};

export const testApiList = (payload: any) => {
  return {
    type: apiListTypes.TEST_API_LIST,
    payload,
  };
};

export const testApiListSuccess = (payload: any) => ({
  type: apiListTypes.TEST_API_LIST_SUCCESS,
  payload,
});

export const testApiListFail = (error: any) => ({
  type: apiListTypes.TEST_API_LIST_FAIL,
  payload: error,
});

export const testApiListReset = () => ({
  type: apiListTypes.TEST_API_LIST_RESET,
});


export const getLocationShopify = (payload: any) => {
  return {
    type: apiListTypes.GET_LOCATION_SHOPIFY,
    payload,
  };
};

export const getLocationShopifySuccess = (payload: any) => ({
  type: apiListTypes.GET_LOCATION_SHOPIFY_SUCCESS,
  payload,
});

export const getLocationShopifyFail = (error: any) => ({
  type: apiListTypes.GET_LOCATION_SHOPIFY_FAIL,
  payload: error,
});
